(function(){
  function dotsFor(track, dotsEl, cls){
    if(!track||!dotsEl) return function(){};
    var n=track.children.length; dotsEl.innerHTML='';
    for(var i=0;i<n;i++){var d=document.createElement('i');dotsEl.appendChild(d);}
    function upd(){var i=Math.round(track.scrollLeft/track.clientWidth);[].forEach.call(dotsEl.children,function(d,k){d.className=k===i?'on':''});}
    track.addEventListener('scroll',function(){window.requestAnimationFrame(upd)},{passive:true}); upd(); return upd;
  }
  function go(track,dir){track.scrollBy({left:dir*track.clientWidth,behavior:'smooth'});}
  // Galleri
  document.querySelectorAll('[data-ly-gallery]').forEach(function(g){
    var t=g.querySelector('.ly-gal__track'); dotsFor(t,g.querySelector('[data-ly-gdots]'));
    g.querySelector('[data-ly-gprev]').onclick=function(){go(t,-1)};
    g.querySelector('[data-ly-gnext]').onclick=function(){go(t,1)};
  });
  // Karuseller (omtaler / kolonner)
  document.querySelectorAll('[data-ly-carousel]').forEach(function(t){
    var wrap=t.parentNode, nav=wrap.querySelector('.ly-reviews__nav'); if(!nav) return;
    dotsFor(t,nav.querySelector('[data-ly-dots]'));
    nav.querySelector('[data-ly-prev]').onclick=function(){go(t,-1)};
    nav.querySelector('[data-ly-next]').onclick=function(){go(t,1)};
  });
  // Før/etter-glidebryter
  document.querySelectorAll('[data-ly-ba]').forEach(function(b){
    var r=b.querySelector('input'); r.addEventListener('input',function(){b.style.setProperty('--pos',r.value+'%')});
  });
  // Pakkevalg
  document.querySelectorAll('[data-ly-offer]').forEach(function(f){
    var opts=f.querySelectorAll('.ly-bundle');
    function sel(){opts.forEach(function(o){o.classList.toggle('is-on',o.querySelector('input').checked)})}
    opts.forEach(function(o){o.querySelector('input').addEventListener('change',sel)}); sel();
    f.addEventListener('submit',function(e){
      if(f.hasAttribute('data-preview')){e.preventDefault();var m=f.querySelector('.ly-prevmsg');if(!m){m=document.createElement('p');m.className='ly-prevmsg';m.style.cssText='text-align:center;font-size:13px;margin:8px 0 0';f.querySelector('[data-ly-atc]').after(m);}m.textContent='Forhåndsvisning: i Shopify legges valgt pakke i handlekurven og kunden sendes til kassen.';m.scrollIntoView({block:'center',behavior:'smooth'});return;}
      e.preventDefault(); var id=f.querySelector('input[name="id"]:checked').value;
      if(window.lyAddToCart){window.lyAddToCart(id);return}
      var btn=f.querySelector('[data-ly-atc]'); btn.disabled=true;
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:1}]})})
        .then(function(r){if(!r.ok)throw 0;window.location.href='/checkout'})
        .catch(function(){btn.disabled=false;f.submit()});
    });
  });
  // Sticky knapp
  var st=document.querySelector('[data-ly-sticky]'), atc=document.querySelector('[data-ly-atc]');
  if(st&&atc){
    new IntersectionObserver(function(es){es.forEach(function(e){st.classList.toggle('on',!e.isIntersecting&&e.boundingClientRect.top<0)})}).observe(atc);
    st.querySelector('button').onclick=function(){var f=document.querySelector('[data-ly-offer]');f.requestSubmit?f.requestSubmit():f.dispatchEvent(new Event('submit',{cancelable:true}))};
  }

  // Videor: spela när de syns (och vid första tryck – iPhone i strömsparläge kräver en gest)
  (function(){var vs=[].slice.call(document.querySelectorAll('video'));if(!vs.length)return;
    vs.forEach(function(v){v.muted=true;v.setAttribute('muted','');v.playsInline=true});
    function play(v){var p=v.play();if(p&&p.catch)p.catch(function(){})}
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)play(e.target);else e.target.pause()})},{threshold:.25});vs.forEach(function(v){io.observe(v)})}else vs.forEach(play);
    function kick(){vs.forEach(function(v){var r=v.getBoundingClientRect();if(r.bottom>0&&r.top<innerHeight)play(v)});window.removeEventListener('touchstart',kick);window.removeEventListener('click',kick)}
    window.addEventListener('touchstart',kick,{passive:true});window.addEventListener('click',kick);
  })();
  // Flere omtaler
  var more=document.querySelector('[data-ly-revmore]');
  if(more){more.onclick=function(){var h=document.querySelectorAll('.ly-rcard.is-hidden');for(var i=0;i<10&&i<h.length;i++)h[i].classList.remove('is-hidden');if(h.length<=10)more.remove();};}
})();
